import React from "react";
import { HOME } from "@/constants/testIds";
import { ShipRouteTracker } from "./ShipRouteTracker";

/**
 * Premium shipment visibility dashboard mock.
 * Stylised world-map SVG with one glowing route (Mersin → Suez → Mombasa).
 */
export const ShipmentDashboard = () => {
  return (
    <div
      data-testid={HOME.heroDashboard}
      className="relative glass rounded-[22px] p-3 md:p-4"
    >
      {/* Window chrome */}
      <div className="flex items-center justify-between px-2 py-1.5">
        <div className="flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-[hsla(0,72%,60%,0.5)]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[hsla(38,92%,55%,0.5)]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[hsla(217,85%,48%,0.5)]" />
        </div>
        <div className="text-[10.5px] font-mono ink-soft">demaxtore.workspace / tracking / SH-2481</div>
        <div className="text-[10.5px] font-mono text-emerald flex items-center gap-1">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald dot-pulse" />
          Live
        </div>
      </div>

      <div data-testid={HOME.heroMap} className="mt-2">
        <ShipRouteTracker />
      </div>
    </div>
  );
};
